// DO NOT CHANGE
// Compiled by gulp ngtemplates:module. Adds templates to $templateCache.

/* jshint ignore:start */
angular.module("saturn.webglRenderer").run(["$templateCache", function($templateCache) {$templateCache.put("saturn/webglRenderer/webglRenderer.tpl.html","<iframe class=\"webgl-renderer-iframe\" ng-src=\"{{webglRendererCtrl.iframeUrl}}\"> </iframe>\n");}]);
/* jshint ignore:end */


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/webglRenderer/src/templates.js